<template>
  <v-footer
    height="auto"
    color="primary lighten-1"
    absolute
  >
    <v-layout
      justify-center
    > 
    <v-flex
        primary
        lighten-2
        py-3
        text-xs-left
        white--text
        xs12
        class="ml-5"
      >
        <strong>{{ $t('footer.developmentByEpicor') }}</strong>
      </v-flex>
      
      <v-btn
        @click="to('version')"
        color="white"
        flat
        round
      >
      <v-icon class="mr-1">new_releases</v-icon>
      {{ $t('footer.version') }}</v-btn>

      <v-flex
        primary
        lighten-2
        py-3
        text-xs-right
        white--text
        xs12
        class="mr-5"
      >
      <strong>Copyright© {{ new Date().getFullYear() }}. {{$t('footer.copyright')}}</strong>
      </v-flex>
    </v-layout>
  </v-footer>
</template>

<script>
import { inPage, to } from '@/utils';
export default {
  name: "footer",
  props: {
    skin: {
      type: Object,
      required: true
    }
  },
  methods: {
    to,
    inPage,
  }
}
</script>